import { PageInfo, Scalars } from './types.generated'

export enum DataFetchDirection {
  START_FROM_LAST,
  START_FROM_FIRST,
}

export type Connection<TNode extends object> = { edges: { cursor: Scalars['Cursor']; node: TNode }[]; pageInfo: PageInfo }
